export default __webpack_public_path__ + "static/media/doctor6.eef84e7d.jpg";